import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { PodcastPlayerEntry } from "frontend/contentful/schema/blocks";
import { RenderContentfulRichText } from "frontend/contentful/components/utils/render-contentful-rich-text";
import { useContentful } from "frontend/hooks/use-contentful";
import { PodcastPlayerProps } from "design-system/components/blocks/podcast-player/podcast-player";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { createMediaAssetProps } from "../primitives/media-asset.props";

export const createPodcastPlayerProps = createContentfulProps<
  PodcastPlayerEntry,
  PodcastPlayerProps
>(({ entry, createEditAttributes }) => {
  const { getEntry } = useContentful();
  const embed = getEntry(entry.fields.embedSource);

  const props: PodcastPlayerProps = {
    align: entry.fields.alignment,
    srcType: embed?.fields.episodeSourceType,
    episodeNum: embed?.fields.episodeNumber,
    embedUrl: embed?.fields.embedSourceURL,
    title: embed?.fields.title,
    header: createComponentHeaderProps(entry.fields.header),
    caption: <RenderContentfulRichText document={entry.fields.caption} />,
    transcript: (
      <RenderContentfulRichText document={embed?.fields.transcript} />
    ),
    editAttributes: {
      title: createEditAttributes({
        entry: entry.fields.embedSource,
        fieldId: "title",
      }),
      caption: createEditAttributes({ entry, fieldId: "caption" }),
    },
  };

  if (embed?.fields.video) {
    props.video = createMediaAssetProps(embed.fields.video);
  }

  return props;
});
